import { render, staticRenderFns } from "./OverviewBusinessSituation.vue?vue&type=template&id=0b2a51cc&scoped=true"
import script from "./OverviewBusinessSituation.vue?vue&type=script&lang=js"
export * from "./OverviewBusinessSituation.vue?vue&type=script&lang=js"
import style0 from "./OverviewBusinessSituation.vue?vue&type=style&index=0&id=0b2a51cc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a51cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2a51cc')) {
      api.createRecord('0b2a51cc', component.options)
    } else {
      api.reload('0b2a51cc', component.options)
    }
    module.hot.accept("./OverviewBusinessSituation.vue?vue&type=template&id=0b2a51cc&scoped=true", function () {
      api.rerender('0b2a51cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operateKanban/components/OverviewBusinessSituation.vue"
export default component.exports